export const GET_GOOD_CATEGORIES = "GET_GOOD_CATEGORIES";
export const GET_GOOD_CATEGORY_BY_ID = "GET_GOOD_CATEGORY_BY_ID";
export const UPDATE_GOOD_CATEGORY = "UPDATE_GOOD_CATEGORY";
export const DELETE_GOOD_CATEGORY = "DELETE_GOOD_CATEGORY";
export const CREATE_GOOD_CATEGORY = "CREATE_GOOD_CATEGORY";
